/* eslint-disable
    prefer-rest-params
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import _ from 'underscore';

import EntryActions from 'actions/EntryActions';
import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as navigation from 'Navigation';
import notifications from 'notifications';
import * as popup from 'Popup';

class BaseEntryProtocolTabState extends navigation.TabState {
  defaults() {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.defaults(), {
      title: 'Protocol',
      closeable: true,
      protocolCid: null,
      file: null, // entry or template
      preferenceKey: navigation.PREFERENCE_KEY_IGNORE,
    });
  }

  initialize(attrs, options) {
    this.printHandler = this.printHandler.bind(this);
    super.initialize(...arguments);

    switch (attrs.file.fileType()) {
      case ModelTypeConstants.ENTRY:
        this.set({printOptions: ['protocol', 'entry']});
        break;
      case ModelTypeConstants.TEMPLATE:
      case ModelTypeConstants.STAGE_ENTRY:
        this.set({printOptions: []}); // TODO(T8957): support print
        break;
      default:
        throw new Error('Unexpected file type');
    }
  }

  addProtocol(protocol) {
    return this.file().addProtocol(protocol);
  }

  updateProtocol(op) {
    return this.file().updateProtocol(this.get('protocolCid'), op);
  }

  removeProtocol() {
    return this.file().removeProtocol(this.get('protocolCid'));
  }

  revertProtocol(protocol, selectionData) {
    return this.file().revertProtocol(protocol, selectionData);
  }

  printHandler(type) {
    assert(this.file().fileType() === ModelTypeConstants.ENTRY);
    switch (type) {
      case 'entry':
        EntryActions.print(this.file().id, {showNote: true});
        break;
      case 'protocol': {
        const protocol = this.protocol();
        if (protocol.externalFile) {
          notifications.info('To print this protocol, please download the file.');
          return;
        }
        EntryActions.print(this.file().id, {showNote: false, protocolCids: [protocol.cid]});
        break;
      }
      default:
        throw new Error(`Unexpected print handler type ${type}`);
    }
  }

  printOptions() {
    return this.get('printOptions');
  }

  protocol() {
    return _.findWhere(this.file().entryProtocols(), {cid: this.get('protocolCid')});
  }

  file() {
    return this.get('file');
  }

  close() {
    new popup.Confirm({
      title: 'Remove protocol?',
      msg: `Are you sure you want to remove this protocol from the entry? Any changes you have made \
will be lost.`,
    })
      .choice('Remove Protocol', 'btn-af-danger', () => {
        this.removeProtocol();
      })
      .choice('Cancel', 'btn-af-default')
      .show();
  }
}

export default BaseEntryProtocolTabState;
